"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrl = void 0;
const InputValidationError_1 = require("./InputValidationError");
// Check if the value has correct url format
const urlValidationRegex = /^(https?:\/\/|(www\.))?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()!@:%_\+.~#?&\/\/=]*$/;
function isUrl(value, errorMessage) {
    if (urlValidationRegex.test(value)) {
        return;
    }
    throw new InputValidationError_1.default(errorMessage);
}
exports.isUrl = isUrl;
// ascii: [\x20-\x7E\x80-\xFF]
